"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DeliveryOrder {
}
exports.default = DeliveryOrder;
//# sourceMappingURL=DeliveryOrder.js.map